import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { SpaceModel } from "src/app/_models/space.model";
import { SpaceService } from "src/app/_services/space.service";
import { ImagePreviewComponent } from "../../../image-preview/image-preview.component";

@Component({
  selector: "app-space-map-assign-space",
  templateUrl: "./space-map-assign-space.component.html",
  styleUrls: ["./space-map-assign-space.component.scss"],
})
export class SpaceMapAssignSpaceComponent implements OnInit {
  constructor(
    private modalCtrl: ModalController,
    public spaceServ: SpaceService
  ) {}

  @Input()
  selectedSpace;

  @Input()
  spaceList: SpaceModel[];

  spaceListToShow: SpaceModel[];

  markedSpace: SpaceModel = null;

  showAllSpaces: boolean = false;

  ngOnInit() {
    this.spaceListToShow = this.spaceList.filter(
      (space: SpaceModel) => !space.posX && !space.posY
    );
  }

  close() {
    this.modalCtrl.dismiss();
  }

  markSpace(space: SpaceModel) {
    this.selectedSpace = space;
  }

  assignSpaceToMap() {
    this.modalCtrl.dismiss(this.selectedSpace, "assignSpace");
  }

  onChangeSearch(event) {
    if (event.length > 0) {
      this.spaceListToShow = this.spaceListToShow.filter(
        (space: SpaceModel) => {
          if (this.showAllSpaces) {
            return space.name.toLowerCase().includes(event.toLowerCase());
          } else {
            return (
              space.name.toLowerCase().includes(event.toLowerCase()) &&
              !space.posX &&
              !space.posY
            );
          }
        }
      );
    } else {
      if (this.showAllSpaces) {
        this.spaceListToShow = this.spaceList;
      } else {
        this.spaceListToShow = this.spaceList.filter(
          (space: SpaceModel) => !space.posX && !space.posY
        );
      }
    }
  }

  toggleAssignedSpaces() {
    this.showAllSpaces = !this.showAllSpaces;

    if (this.showAllSpaces) {
      this.spaceListToShow = this.spaceList;
    } else {
      this.spaceListToShow = this.spaceList.filter(
        (space: SpaceModel) => !space.posX && !space.posY
      );
    }
  }

  async onImagePreview($event, url) {
    $event.stopPropagation();
    $event.preventDefault();

    const modal = await this.modalCtrl.create({
      component: ImagePreviewComponent,
      componentProps: { src: url },
      animated: true,
      cssClass: "image-preview-present",
    });
    modal.present();
  }
}
